import React from 'react';
import { Rocket, Sparkles, Globe2, TrendingUp } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const MaintenanceBanner = () => {
  return (
    <Card className="mb-8 border-0 shadow-xl overflow-hidden">
      <div className="relative bg-gradient-to-br from-emerald-500 via-teal-500 to-cyan-600 p-8">
        {/* Animated background pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-64 h-64 bg-white rounded-full blur-3xl transform -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl transform translate-x-1/2 translate-y-1/2"></div>
        </div>
        
        <CardContent className="relative p-0">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center">
                <Rocket className="h-8 w-8 text-white" />
              </div>
            </div>
            
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-3">
                <Sparkles className="h-5 w-5 text-yellow-300" />
                <h3 className="text-2xl font-bold text-white">
                  Exciting Upgrade in Progress
                </h3>
              </div>
              
              <p className="text-white/95 text-lg mb-4 leading-relaxed">
                We're enhancing our <strong>Referral Partner Program</strong> with cutting-edge features designed to maximize your earning potential and streamline your partnership experience.
              </p>
              
              <div className="grid md:grid-cols-3 gap-4 mb-4">
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
                  <div className="flex items-center gap-2 mb-2">
                    <TrendingUp className="h-5 w-5 text-yellow-300" />
                    <span className="font-semibold text-white">Enhanced Tracking</span>
                  </div>
                  <p className="text-white/80 text-sm">Real-time commission analytics</p>
                </div>
                
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
                  <div className="flex items-center gap-2 mb-2">
                    <Globe2 className="h-5 w-5 text-yellow-300" />
                    <span className="font-semibold text-white">Global Reach</span>
                  </div>
                  <p className="text-white/80 text-sm">Expanded to 60+ countries</p>
                </div>
                
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
                  <div className="flex items-center gap-2 mb-2">
                    <Sparkles className="h-5 w-5 text-yellow-300" />
                    <span className="font-semibold text-white">Modern Dashboard</span>
                  </div>
                  <p className="text-white/80 text-sm">State-of-the-art interface</p>
                </div>
              </div>
              
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4 border-l-4 border-yellow-300">
                <p className="text-white font-medium">
                  🚀 <strong>Coming Soon:</strong> The updated Referral Partner Program will launch in the coming days. 
                  Get ready to join our global network of successful partners!
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </div>
    </Card>
  );
};

export default MaintenanceBanner;
